import { Injectable, signal } from '@angular/core';
import { loadSavedState, saveState } from './saved-state';

export type PlayerMode = 'deezer' | 'preview';

const STATE_KEY = 'player.mode';

/**
 * How songs are played. 'deezer' (default) embeds Deezer's own player, which can play full songs once the
 * listener is logged in to Deezer; 'preview' uses the 30-second clips from Deezer's public API.
 * Only one embedded player is open at a time (activeKey).
 */
@Injectable({ providedIn: 'root' })
export class PlayerModeService {
  readonly mode = signal<PlayerMode>(loadSavedState(STATE_KEY, { mode: 'deezer' }).mode === 'preview' ? 'preview' : 'deezer');
  /** Key of the embedded player that is currently open, e.g. 'track:123' or 'album:456'. */
  readonly activeKey = signal<string | null>(null);

  setMode(mode: PlayerMode): void {
    this.mode.set(mode);
    this.activeKey.set(null);
    saveState(STATE_KEY, { mode });
  }

  toggleActive(key: string): void {
    this.activeKey.update(current => current === key ? null : key);
  }
}
